import { Gateway } from 'index';

/**
 * Authorized download
 *
 * Handles authorized downloads (adds jwt-token)
 *
 * @param {string} fallBackName fallback filename if response has no header
 * @param {string} url url of file
 */
export const handleDownload = async (fallBackName: string, url: string) => {
  const token = localStorage.getItem('jwt-token');
  const refreshToken = localStorage.getItem('refresh-token');
  const response = await Gateway.get(url, {
    headers: {
      authorization: token ? `Bearer ${token}` : '',
      refresh: refreshToken || ''
    },
    responseType: 'blob'
  });
  const blob = new Blob([response.data]);

  const filenameHeader = response.headers['content-disposition'];

  let file: string | undefined = undefined;
  if (filenameHeader) {
    const filename = response.headers['content-disposition']
      .split('filename=')[1]
      .replaceAll('"', '');

    file = `${filename}`;
  }

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = file ?? fallBackName;
  link.click();
};
